import React from "react";

export const WhatIsWorkspace = ({ farmText, orgText, workspaceText }: { farmText: string, orgText: string, workspaceText: string }) => (
<svg
    xmlns="http://www.w3.org/2000/svg"
    width={388}
    height={160}
    fill="none"
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={388}
        height={160}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M388 0H0v160h388V0Z" />
      </mask>
      <g mask="url(#b)">
        <path fill="#F3F4F6" d="M388 0H0v160h388V0Z" />
        <path
          fill="#B3E7B5"
          d="M39.542 89.684c9.174 2.614 20.016 11.236 27.165 22.344h-99.822s2.47-5.133 7.798-10.129c7.799-7.31 17.554-11.143 25.086-13.007 13.128-3.247 27.035-2.838 39.773.792Z"
        />
        <path
          fill="#B3E7B5"
          fillRule="evenodd"
          d="M171.122 100.71c-8.909-7.399-18.984-10.853-28.104-13.788-19.293-6.209-40.108-4.15-54.959 0-11.409 3.188-26.183 9.746-37.995 22.25-8.072 8.545-6.465 6.901-6.465 6.901h140.256l-.027-.049h92.844c-8.827-11.163-22.215-19.827-33.542-22.454-15.727-3.648-32.899-4.06-49.108-.795-6.834 1.376-15.15 3.82-22.9 7.935Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          stroke="#00004B"
          strokeWidth={0.319}
          d="M193.568 51.977c5.014 5.364 4.719 17.301 4.096 23.028-.821.332-4.438 1.204-12.336 2.038-10.859 1.146-17.296-1.365-21.766-5.262-7.891-6.88-6.025-15.658-8.55-24.472.66.16 4.061.34 11.848-1.054 11.348-2.032 19.871-1.594 26.708 5.722ZM202.828 32.982c-5.022 5.401-4.65 17.348-3.985 23.076.83.327 4.482 1.178 12.452 1.964 10.958 1.08 17.433-1.473 21.916-5.4 7.914-6.935 5.977-15.712 8.467-24.55-.664.164-4.093.366-11.954-.981-11.456-1.964-20.047-1.473-26.896 5.891ZM202.828 86.26c-5.022-5.4-4.65-17.348-3.985-23.076.83-.327 4.482-1.178 12.452-1.964 10.958-1.08 17.433 1.473 21.916 5.4 7.914 6.936 5.977 15.712 8.467 24.55-.664-.164-4.093-.366-11.954.982-11.456 1.963-20.047 1.473-26.896-5.892Z"
        />
        <path
          fill="#73DC78"
          fillRule="evenodd"
          d="M87.571 89.273c14.686 3.412 28.86 9.095 41.84 18.711 6.503-1.617 12.824-2.797 18.507-3.639 26.058-3.86 53.664-3.374 78.948.94 14.329 2.445 28.047 6.883 40.157 15.096h9.089c8.377-6.026 23.846-11.971 33.542-14.103 17.678-3.888 36.406-3.398 53.559.947 9.626 2.438 20.51 9.955 24.847 13.156h.94v.702c.641.485.992.765.992.765l-.992-.005v38.538H-68v-32.464h-23.363s4.206-3.719 17.472-13.855c19.415-14.834 43.698-22.613 62.45-26.394 32.68-6.59 67.302-5.76 99.012 1.605Z"
          clipRule="evenodd"
        />
        <path
          fill="#DFE2E7"
          d="M322.513 46.201h-32.679c-1.152-.395-4.908-1.953-4.713-5.626.314-5.922 7.541-4.738 6.912-5.33.21-.592.058-3.093 2.2-3.85 2.142-.756 4.211 0 5.342.889.254.2 0-5.626 5.027-6.218 6.599-.778 6.874 5.626 7.227 5.33.943-.79 2.514-2.529 5.971-1.777 3.77.82 4.189 4.343 3.77 5.922-.628.296 4.399-.296 5.342 4.442.707 3.553-2.514 5.33-4.399 6.218Z"
        />
        <path
          fill="#fff"
          d="M334.486 55.236h-32.679c-1.153-.395-4.909-1.953-4.714-5.626.315-5.922 7.542-4.738 6.913-5.33.21-.592.058-3.093 2.2-3.85 2.142-.756 4.21 0 5.341.889.255.2 0-5.626 5.028-6.218 6.599-.778 6.874 5.626 7.227 5.33.943-.79 2.514-2.529 5.97-1.777 3.771.82 4.19 4.343 3.771 5.922-.629.296 4.399-.296 5.342 4.442.707 3.553-2.514 5.33-4.399 6.218Z"
        />
        <path
          fill="#14803C"
          d="M358 99H237a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h121a4 4 0 0 0 4-4v-24a4 4 0 0 0-4-4ZM297.5 137l6-6h-12l6 6Z"
        />
        <text
          xmlSpace="preserve"
          fill="#fff"
          fontFamily="Inter"
          fontSize={12}
          letterSpacing="0em"
          style={{
            whiteSpace: "pre",
          }}
        >
          <tspan x={238} y={119.364}>
            {workspaceText}
          </tspan>
        </text>
        <g filter="url(#c)">
          <path
            fill="#00004B"
            d="M180 87.5H65a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h115a4 4 0 0 0 4-4v-24a4 4 0 0 0-4-4ZM190 103.5l-6 6v-12l6 6Z"
          />
          <text
            xmlSpace="preserve"
            fill="#fff"
            fontFamily="Inter"
            fontSize={12}
            letterSpacing="0em"
            style={{
              whiteSpace: "pre",
            }}
          >
            <tspan x={64} y={107.864}>
              {orgText}
            </tspan>
          </text>
        </g>
        <path
          fill="#fff"
          d="M139 30.5H24a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h115a4 4 0 0 0 4-4v-24a4 4 0 0 0-4-4ZM149 46.5l-6 6v-12l6 6Z"
        />
        <text
          xmlSpace="preserve"
          fill="#000"
          fontFamily="Inter"
          fontSize={12}
          letterSpacing="0em"
          style={{
            whiteSpace: "pre",
          }}
        >
          <tspan x={24} y={51.364}>
            {farmText}
          </tspan>
        </text>
        <path
          fill="#00004B"
          fillRule="evenodd"
          d="M196.127 60.97h.001c.088-8.897 7.328-16.083 16.247-16.083v3.683c-6.897 0-12.497 5.558-12.563 12.44l.702 19.47a16.201 16.201 0 0 1 11.861-5.144v3.683c-5.256 0-9.758 3.227-11.633 7.808l.91 25.219h-7.367l1.419-39.342c-1.316-5.532-6.289-9.646-12.224-9.646v-3.683c5.023 0 9.513 2.279 12.493 5.859l.154-4.263Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h388v160H0z" />
      </clipPath>
      <filter
        id="c"
        width={145}
        height={48}
        x={53}
        y={81.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_0_3" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_0_3"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
